<div class="col-md-12 main-heading">
  <div class="d-flex">
    <a routerLink="/index">
      <div class="icon-heading"><img src="assets/images/pages-icon/backbtn.png" class="img-responsive"> </div>
    </a>
    <div class="caption-heading">Black List / White List</div>
  </div>
</div>
<div class="col-md-12 pagecustom">
  <div class="page-wrapper">
    <div class="row main-container boxscroll">
      <div class="block-section width-lg-metro" style="width: 100%; ">
        <div class="heading-m" style="height: 37px;">
        </div>
        <div class="list-sidebar">
          <form [formGroup]="SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST_FORM"
            (ngSubmit)="SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST_FORM_SUBMIT()">
            <table style="width: 300px;">
              <tbody>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input exampleCheck" id="exampleCheckAll"
                        formControlName="exampleCheckAll" style="margin-right: 6px;" (click)="updateValue('2')">
                      <label class="form-check-label" for="exampleCheckAll">All</label>
                    </div>
                  </td>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input exampleCheck" id="exampleCheckActive"
                        formControlName="exampleCheckActive" style="margin-right: 6px;" (click)="updateValue('1')">
                      <label class="form-check-label" for="exampleCheckActive">Active</label>
                    </div>
                  </td>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input exampleCheck" id="exampleCheckInactive"
                        formControlName="exampleCheckInactive" style="margin-right: 6px;" (click)="updateValue('0')">
                      <label class="form-check-label" for="exampleCheckInactive">Inactive</label>
                    </div>
                  </td>
                  <td>
                    <button type="submit" class="btn btn-primary">Apply</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <style>
              .tableFixHead {
                width: 100%;
                table-layout: fixed;
                border-collapse: collapse;
              }

              .tableFixHead tbody {
                display: block;
                width: 100%;
                overflow: auto;
                height: 400px;
                word-break: break-all;
              }

              .tableFixHead thead tr {
                display: block;
                width: 99%;
              }

              .tableFixHead th,
              .tableFixHead td {
                padding: 5px 10px;
                width: 200px;
                vertical-align: sub;
              }

              tr:nth-child(even) th[scope=row] {
                background-color: #f2f2f2;
              }

              tr:nth-child(odd) th[scope=row] {
                background-color: #fff;
              }

              tr:nth-child(even) {
                background-color: rgba(0, 0, 0, 0.05);
              }

              tr:nth-child(odd) {
                background-color: rgba(255, 255, 255, 0.05);
              }

              th {
                background: #ABDD93;
              }

              tr:hover {
                background-color: rgb(107, 156, 241);
              }
            </style>
            <div class="tableFixHead">
              <table style="width: 100%;">
                <thead>
                  <tr>
                    <td>
                      Group Name
                    </td>
                    <td>
                      Group Validity Start Date
                    </td>
                    <td>
                      Group Validity End Date
                    </td>
                    <td>
                      Customer Name
                    </td>
                    <td>
                      Customer Validity Start Date
                    </td>
                    <td>
                      Customer Validity End Date
                    </td>
                    <td>
                      Vehicle Number
                    </td>
                    <td>
                      Tag Number
                    </td>
                    <td>
                      Group Status
                    </td>

                    <td>
                      Customer Status
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ratedtl of SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST">
                    <td>{{ratedtl?.GROUP_NAME}}</td>
                    <td>{{ratedtl?.GROUP_VALIDITY_START_DATE}}</td>
                    <td>{{ratedtl?.GROUP_VALIDITY_END_DATE}}</td>
                    <td>{{ratedtl?.CUSTOMER_NAME}}</td>
                    <td>{{ratedtl?.CUSTOMER_VALIDITY_START_DATE}}</td>
                    <td>{{ratedtl?.CUSTOMER_VALIDITY_END_DATE}}</td>
                    <td>{{ratedtl?.VEHICLE_NUMBER}}</td>
                    <td>{{ratedtl?.TAG_NUMBER}}</td>
                    <td>{{ratedtl?.GROUP_STATUS}}</td>
                    <td>{{ratedtl?.CUSTOMER_STATUS}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>